const checkInternetConnection = () => {
  if (!navigator.onLine) {
    return false;
  }
  return true;
};

export { checkInternetConnection };
